// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1ca8a196","345":"9946ebe5","453":"7fc513d0"}[chunkId] + ".chunk.js";
};